import { INTERVIEW_NEW_UPDATE_REQUEST, INTERVIEW_NEW_UPDATE_FAIL,INTERVIEW_NEW_UPDATE_SUCCESS } from "../constants/AuthConstant"

import axios from "axios";
import { toast } from "react-toastify";

export const RescheduledInterviewAction = (data) => {
    return function (dispatch) {
      dispatch({
        type: INTERVIEW_NEW_UPDATE_REQUEST,
        payload: true,
      });
     
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/interview/add_interview`,
        method: "POST",
        data: data,
        headers: {
          "content-type": "application/json",
        },
      };
  
      axios(OPTION)
        .then((res) => {
          dispatch(RescheduleContentPre(res.data));
        
        })
        .catch((error) => {
          dispatch({
            type: INTERVIEW_NEW_UPDATE_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
          toast.error(" Interview already scheduled!");
        });
    };
  };
  export const RescheduleContentPre = (data) => {
    toast.success("Reschedule Successfully!");
  //   setTimeout(() => {
  //     window.location.href = "/interview-planned"
  //  }, 1000)
 
    return {
      type: INTERVIEW_NEW_UPDATE_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };